export default {
    MAP_CLICK  : "MAP_CLICK",
    MAP_CLOSE : "MAP_CLOSE",
    FILTER_SEARCH_ADDED:"FILTER_SEARCH_ADDED",
    MAP_GEO_CENTER:"MAP_GEO_CENTER"
}